import { useState } from 'react';
import { CustomDialog } from '../../components/CustomDialog';
import { ListItemIcon, MenuItem } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { useLazyGetUserListQuery } from '../../services/user';
import './index.scss';
import { Link } from 'react-router-dom';

type TProps = {
  closeAnchorEle: () => void;
  setIsLoadingUsersList: React.Dispatch<
    React.SetStateAction<boolean>
  >;
};

export const Users = ({
  closeAnchorEle,
  setIsLoadingUsersList,
}: TProps) => {
  const [dialogState, setDialogState] = useState(false);
  const [getUsersAPI, { data: usersList }] =
    useLazyGetUserListQuery();

  const handleDialogOpen = () => {
    setIsLoadingUsersList(true);
    getUsersAPI()
      .unwrap()
      .then(() => {
        closeAnchorEle();
        setDialogState(true);
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoadingUsersList(false));
  };

  return (
    <div>
      <MenuItem onClick={handleDialogOpen}>
        <ListItemIcon>
          <GroupsIcon />
        </ListItemIcon>{' '}
        Users
      </MenuItem>
      <CustomDialog
        dialogTitle="Users"
        open={dialogState}
        setOpen={setDialogState}
        maxWidth="md"
        showActions={false}>
        <div className="table-container">
          {usersList?.length ? (
            <table>
              <thead>
                <tr>
                  <th className="w-[200px]">Name</th>
                  <th className="w-[140px]">UGDN</th>
                  <th className="w-[360px]">Email</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody className="w-full">
                {usersList?.map((user) => (
                  <Link
                    key={user.id}
                    to={`?userId=${user.id}`}
                    target={'_blank'}>
                    <tr key={user.id}>
                      <td className="w-[200px]">
                        {user.full_name}
                      </td>
                      <td className="w-[140px]">
                        {user.ugdn_id}
                      </td>
                      <td className="w-[360px]">
                        {user.username}
                      </td>
                      <td>{user.role}</td>
                    </tr>
                  </Link>
                ))}
              </tbody>
            </table>
          ) : (
            'No Data Found please refresh the page'
          )}
        </div>
      </CustomDialog>
    </div>
  );
};
